import { FilterFieldValuePrimitiveSchema } from 'shared/api/requests/audience/schemas'
import { makeGuardFromSchema } from 'shared/api/requests/utils'

export const isFilterFieldValuePrimitive = makeGuardFromSchema(FilterFieldValuePrimitiveSchema)
